module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/17-8f36a332e6ded5eeb1416cbd3070b2dc.png";